import { AppState } from 'src/store/app/types';
import { PayloadAction } from '@reduxjs/toolkit';

const setAppDraftsUrlReducer = (state: AppState, action: PayloadAction<string | undefined>) => {
  state.draftsUrl = action.payload;
};

export default setAppDraftsUrlReducer;
